import React from 'react';
import { DAYS, MONTHS, YEARS } from '../../constants/chatConstants';

export default function DatePickerModal({ 
  isOpen, 
  onClose, 
  birthDetails, 
  handleBirthDetailsChange,
  getDaysInMonth 
}) {
  if (!isOpen) return null;

  const selectedDay = birthDetails.birth_day;
  const selectedMonth = birthDetails.birth_month;
  const selectedYear = birthDetails.birth_year;

  return (
    <div className="picker-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="scroll-picker-modal">
        <div className="scroll-picker-header">
          <h3>Select Date of Birth</h3>
        </div>
        <div className="scroll-picker-content">
          <div className="scroll-wheels">
            <div className="scroll-wheel">
              <div className="wheel-label">Day</div>
              <div className="wheel-container">
                {DAYS.map(d => (
                  <div 
                    key={d} 
                    className={`wheel-item ${selectedDay == d ? 'selected' : ''}`} 
                    onClick={() => handleBirthDetailsChange('birth_day', d)}
                  >
                    {String(d).padStart(2, '0')}
                  </div>
                ))}
              </div>
            </div>

            <div className="scroll-wheel">
              <div className="wheel-label">Month</div>
              <div className="wheel-container">
                {MONTHS.map(m => (
                  <div 
                    key={m.value} 
                    className={`wheel-item ${selectedMonth == m.value ? 'selected' : ''}`} 
                    onClick={() => handleBirthDetailsChange('birth_month', m.value)}
                  >
                    {m.name.substring(0, 3).toUpperCase()}
                  </div>
                ))}
              </div>
            </div>

            <div className="scroll-wheel">
              <div className="wheel-label">Year</div>
              <div className="wheel-container">
                {YEARS.map(y => (
                  <div 
                    key={y} 
                    className={`wheel-item ${selectedYear == y ? 'selected' : ''}`} 
                    onClick={() => handleBirthDetailsChange('birth_year', y)}
                  >
                    {y}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="picker-buttons">
          <button className="picker-btn picker-btn-cancel" onClick={onClose}>CANCEL</button>
          <button 
            className="picker-btn picker-btn-ok" 
            onClick={onClose} 
            disabled={!selectedDay || !selectedMonth || !selectedYear}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
